import React from 'react'
import { withI18n } from '~/hocs'
import { assetURL } from '~/utils'
import { NextPage } from 'next'
import { AppCommonProps } from 'types/app'
import Link from 'next/link'
import { routes } from '~/router'
import { Modal } from 'react-bootstrap'
import config from '~/config'

const FirstDLModal: NextPage<AppCommonProps> = ({ show, onHide, imageUrl, emailToken }) => {
    return (
        <Modal show={show} onHide={onHide} centered className="modal-first-download">
            <Modal.Body>
                <a href={`${config.photoUrl}/premium/generate_token_first_download_video?email=${emailToken}`}>
                    <img src={imageUrl} alt="Image" style={{ cursor: 'pointer' }} />
                </a>
            </Modal.Body>
        </Modal>
    )
}
export default withI18n(FirstDLModal)